import { useEffect, useState } from "react";
import DaumPostcode from "react-daum-postcode";

const KakaoApi = (props) => {
  /*header 영역*/
  const pageName = "주소 검색";
  const headerUi = {
    goback: false,
    closeAll: true,
  };
  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);
  /**모바일 기종 분기처리 (ios, 안드로이드, 그 외) */
  const [phoneType, setPhoneType] = useState();
  var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
  // function checkMobile() {
  //   if (varUA.indexOf("android") > -1) {
  //     //안드로이드
  //     setPhoneType("android");
  //     return "android";
  //   } else if (
  //     varUA.indexOf("iphone") > -1 ||
  //     varUA.indexOf("ipad") > -1 ||
  //     varUA.indexOf("ipod") > -1
  //   ) {
  //     //IOS
  //     setPhoneType("ios");
  //     return "ios";
  //   } else {
  //     //아이폰, 안드로이드 외
  //     setPhoneType("other");
  //     return "other";
  //   }
  // }
  // useEffect(() => {
  //   checkMobile();
  // }, []);

  const handle = {
    // 주소 선택 이벤트
    selectAddress: (data) => {
      // 각 주소의 노출 규칙에 따라 주소를 조합한다.
      // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
      var fullAddr = ""; // 최종 주소 변수
      var extraAddr = ""; // 조합형 주소 변수

      // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (data.userSelectedType === "R") {
        // 사용자가 도로명 주소를 선택했을 경우
        fullAddr = data.roadAddress;
      } else {
        // 사용자가 지번 주소를 선택했을 경우(J)
        fullAddr = data.jibunAddress;
      }

      // 사용자가 선택한 주소가 도로명 타입일때 조합한다.
      if (data.userSelectedType === "R") {
        //법정동명이 있을 경우 추가한다.
        if (data.bname !== "") {
          extraAddr += data.bname;
        }
        // 건물명이 있을 경우 추가한다.
        if (data.buildingName !== "") {
          extraAddr +=
            extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
        fullAddr += extraAddr !== "" ? " (" + extraAddr + ")" : "";
      }

      var postData = {
        // postcode: data.postcode,
        zonecode: data.zonecode,
        addr: fullAddr,
      };

      if (varUA.indexOf("android") > -1) {
        //안드로이드
        window.postMessageToAndroid.setAddress(
          data.postcode,
          data.zonecode,
          fullAddr
        );
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1
      ) {
        //IOS
        window.webkit.messageHandlers.movusCallBack.postMessage(postData);
        // setPhoneType("ios");
        return "ios";
      } else {
        //아이폰, 안드로이드 외
        window.postMessageToAndroid.setAddress(
          data.postcode,
          data.zonecode,
          fullAddr
        );
        return "other";
      }
    },
  };

  return (
    <div className="container kakao_api">
      <DaumPostcode
        onComplete={handle.selectAddress} // 값을 선택할 경우 실행되는 이벤트
        autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정
      />
    </div>
  );
};
export default KakaoApi;
